const actions = {
    FETCH_FINAL : 'FETCH_FINAL',
    FETCH_FINAL_ATTENDANCE : 'FETCH_FINAL_ATTENDANCE',

    fetchFinalAction: (data) => {
        return {
            type: actions.FETCH_FINAL,
            data: data
        };
    },
    fetchFinalAttendanceAction: (data) => {
        return {
            type: actions.FETCH_FINAL_ATTENDANCE,
            data: data
        };
    },
}

export default actions;
